import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Download, FileText, Clock } from 'lucide-react';
import { Section } from '@/components/Section';
import { Button } from '@/components/ui/button';

export function CareerHero() {
  return (
    <Section>
      <div className="max-w-4xl">
        <motion.span
          className="text-sm text-primary font-medium uppercase tracking-widest mb-4 block"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          Career
        </motion.span>
        <motion.h1
          className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 tracking-tight"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          data-testid="career-headline"
        >
          Career & Experience
        </motion.h1>

        <motion.blockquote
          className="text-2xl md:text-3xl text-white font-semibold leading-snug mb-6 border-l-4 border-primary pl-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15 }}
          data-testid="career-quote"
        >
          "I am the sum total of everything I've ever done and experienced in my lifetime."
        </motion.blockquote>

        <motion.p
          className="text-lg text-slate-300 leading-relaxed mb-8 max-w-3xl"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Over four decades of work across systems architecture, enterprise technology, defense, entrepreneurship, publishing, and artificial intelligence—each chapter building on the last, each experience shaping what comes next.
        </motion.p>

        <motion.div
          className="flex flex-wrap gap-3"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25 }}
        >
          <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary/10" data-testid="download-resume-btn">
            <a href="/assets/R_Dale_Brunet_Resume.pdf" download>
              <Download className="mr-2 h-4 w-4" />
              Download Resume
            </a>
          </Button>
          <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary/10" data-testid="download-portfolio-btn">
            <a href="/assets/R_Dale_Brunet_Career_Portfolio.pdf" download>
              <FileText className="mr-2 h-4 w-4" />
              Download Career Portfolio
            </a>
          </Button>
          <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary/10" data-testid="view-history-btn">
            <Link to="/career-history">
              <Clock className="mr-2 h-4 w-4" />
              View Career History
            </Link>
          </Button>
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="career-contact-btn">
            <Link to="/schedule">Schedule a Conversation</Link>
          </Button>
        </motion.div>
      </div>
    </Section>
  );
}
